import { Injectable } from '@angular/core'
import { BaseProviderStatus, BaseShippingProviderService, ProviderStatusEntry } from '../shared/base-shipping-provider.service'

export interface DhlSettings {
  enabled: boolean
  apiKey: string
  apiSecret: string
  accountNumber: string
  originCountryCode: string
  originCityName: string
  originPostalCode: string
}

export interface DhlSettingsStatus extends BaseProviderStatus {
  accountNumberMasked?: string
  originCountryCode?: string
  originCityName?: string
  originPostalCode?: string
}

@Injectable({
  providedIn: 'root'
})
export class DhlSettingsService extends BaseShippingProviderService<DhlSettings, DhlSettingsStatus> {
  protected readonly providerKey = 'dhl'
  protected readonly providerLabel = 'DHL'

  protected mapStatus(entry: ProviderStatusEntry): DhlSettingsStatus {
    return {
      connected: entry.connected,
      enabled: entry.enabled,
      accountNumberMasked: entry.accountNumberMasked,
      originCountryCode: entry.originAddress?.countryCode,
      originCityName: entry.originAddress?.cityName,
      originPostalCode: entry.originAddress?.postalCode
    }
  }

  protected buildSaveBody(projectId: string, settings: DhlSettings): Record<string, unknown> {
    return {
      projectId,
      enabled: settings.enabled,
      apiKey: settings.apiKey,
      apiSecret: settings.apiSecret,
      accountNumber: settings.accountNumber,
      originCountryCode: settings.originCountryCode,
      originCityName: settings.originCityName,
      originPostalCode: settings.originPostalCode,
    }
  }
}
